<!-- 题干组件 -->
<template>
    <div class="screen" :class="seasonClass">
        <div
            class="page"
            :class="group === 1 ? 'page1' : 'page2'"
            :style="pageStyle"
        >
            <div class="userinfo">
                <span class="mr-20"
                    >姓名：{{ userInfo.examinationUserName }}</span
                ><span
                    >比赛号码：{{ addZero(userInfo.examinationNumber) }}</span
                >
            </div>
            <div class="season2-logo">
                <img
                    class="img"
                    src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/logo.png"
                    alt=""
                />
                <img
                    class="img"
                    src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/season4-logo1.png"
                    alt=""
                />
            </div>
            <div class="page-box" :class="'page-box' + group">
                <div class="season2-title season2-title1">
                    <div class="cn">
                        区域决选-{{ levelFormatter(level, "cn") }}
                    </div>
                    <div class="en">
                        Regional Finals {{ levelFormatter(level, "en") }}
                    </div>
                </div>
                <!-- 古往今来 -->
                <div class="content3" v-if="info.quizType === 7">
                    <div class="imageData">
                        <div class="quiz-info">
                            <div class="quiz-number">
                                第{{ info.quizNumber }}题
                            </div>
                            <div class="quiz-image">
                                <img :src="info.choicePic" alt="" />
                            </div>
                            <div class="countdown">{{ formTimeStr }}</div>
                        </div>
                    </div>
                    <div class="answer-area-title">答题区</div>
                    <div class="type3" :class="vertical">
                        <div class="grid-container">
                            <!-- 左侧九宫格 -->
                            <div class="left-grid-wrapper">
                                <div class="grid-title">左侧选择区</div>
                                <el-row class="area2">
                                    <el-col
                                        :span="8"
                                        v-for="(item, index) of fontList"
                                        :key="'left-' + index"
                                    >
                                        <div
                                            class="block2"
                                            :class="item.active ? 'active' : ''"
                                            @click="answerFnLeft(item, index)"
                                        >
                                            {{ item.font }}
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <!-- 右侧九宫格 -->
                            <div class="right-grid-wrapper">
                                <div class="grid-title">右侧选择区</div>
                                <el-row class="area2">
                                    <el-col
                                        :span="8"
                                        v-for="(item, index) of fontListB"
                                        :key="'right-' + index"
                                    >
                                        <div
                                            class="block2"
                                            :class="item.active ? 'active' : ''"
                                            @click="answerFnRight(item, index)"
                                        >
                                            {{ item.font }}
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <img src="../../assets/img/fs.png" class="fullscreen" @click="toFullOrExit" alt=""> -->
        <!-- 比赛未开始 -->
        <el-dialog
            :visible.sync="noStart"
            :close-on-click-modal="false"
            :show-close="false"
            :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'"
            :width="getDialogWidth()"
        >
            <div class="info-panel" :class="'info-panel-' + seasonClass">
                <div class="info-title">
                    <img
                        class="guodu"
                        src="https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png
                        "
                        alt=""
                    />
                    <div class="cn">参赛信息已确认，请耐心等待比赛开始</div>
                    <div class="en word-break">
                        The participation information has been confirmed. Please
                        be patient and wait for the start of the competition.
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="prepare"
            :close-on-click-modal="false"
            :show-close="false"
            :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'"
            :width="getDialogWidth()"
        >
            <div class="info-panel" :class="'info-panel-' + seasonClass">
                <div class="info-title">
                    <img
                        class="guodu"
                        src="
                            https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png
                        "
                        alt=""
                    />
                    <div class="cn">比赛马上开始，请注意聆听题目发音</div>
                    <div class="en word-break">
                        The competition is about to start. Please pay attention
                        and listen carefully to the pronunciation of the
                        questions.
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 比赛暂停 -->
        <el-dialog
            :visible.sync="pause"
            :close-on-click-modal="false"
            :show-close="false"
            :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'"
            :width="getDialogWidth()"
        >
            <div class="info-panel" :class="'info-panel-' + seasonClass">
                <div class="info-title">
                    <img
                        class="guodu"
                        src="
                            https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png
                        "
                        alt=""
                    />
                    <div class="cn">比赛暂停，请听候裁判席安排</div>
                    <div class="en word-break">
                        The competition is suspended. Please wait for the
                        judges’ instructions.
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 两题过渡 -->
        <el-dialog
            :visible="submit && !discardSubmit"
            :close-on-click-modal="false"
            :show-close="false"
            :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'"
            :width="getDialogWidth()"
        >
            <div class="info-panel" :class="'info-panel-' + seasonClass">
                <div class="info-title">
                    <img
                        class="guodu"
                        src="https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png
                        "
                        alt=""
                    />
                    <div class="cn">已提交</div>
                    <div class="en word-break">
                        Your answer has been submitted.
                    </div>
                </div>
                <div class="confirm-button-container">
                    <el-button
                        type="primary"
                        class="confirm-btn"
                        @click="confirmAnswer"
                    >
                        <span class="en">确认（Confirm）</span>
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 题目作废 -->
        <el-dialog
            :visible.sync="isDiscard"
            :close-on-click-modal="false"
            :show-close="false"
            :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'"
            :width="getDialogWidth()"
        >
            <div class="info-panel" :class="'info-panel-' + seasonClass">
                <div class="info-title">
                    <img
                        class="guodu"
                        src="https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png
                        "
                        alt=""
                    />
                    <div class="cn">本题已作废，请注意聆听新题目发音</div>
                    <div class="en word-break">
                        This question has been invalidated. Please pay attention
                        to the pronunciation of the new question.
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 答题完毕 -->
        <el-dialog
            :visible.sync="resultShow"
            :close-on-click-modal="false"
            :show-close="false"
            :custom-class="seasonClass === 'season1' ? '' : 'season2-dialog'"
            :width="getDialogWidth()"
        >
            <div class="info-panel" :class="'info-panel-' + seasonClass">
                <div class="info-title">
                    <img
                        class="guodu"
                        src="https://cdn.spbcn.org/chineseWord/applets/images/logo_yuan.png
                        "
                        alt=""
                    />
                    <div class="cn">作答完毕</div>
                    <div class="en word-break">The answer is completed.</div>
                </div>
                <div class="confirm-button-container">
                    <el-button
                        type="primary"
                        class="confirm-btn"
                        @click="confirmAnswer"
                    >
                        <span class="en">确认（Confirm）</span>
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import env from '@/http/env'
import { queryNationalGroupFormInfoList, saveNationalAnswerResult } from '@/http/wxApi'
export default {
  data () {
    return {
      seasonClass: '',
      pageStyle: {
        height: '100%'
      },
      activityType: '',
      season: '',
      group: 1, // 1-有组别 2无组别
      level: '',
      imgList: [],
      fontList: [], // 答案选项
      fontListB: [], // 备用选项列表
      vertical: '', // 竖屏class
      isFull: false,
      type: -1, // 题型
      timer: null,
      info: {}, // 试题info
      pageTitle: '',
      dict_group: this.$userInfo.dict_group(),
      userInfo: {}, // 登录用户个人信息
      submit: false, // 小题是否已提交
      discardSubmit: false, // 作废题目提交
      pause: false, // 是否暂停
      answerNum: 0, // 选项数量
      chooseFonts: [], // 选项列表
      chooseFontsLeft: [], // 左边九宫格选择的选项
      chooseFontsRight: [], // 右边九宫格选择的选项
      chooseImg: '', // 古往今来选择的图片
      isDiscard: false, // 题目作废
      nextStep: false,
      raceSchedule: '', // 赛程
      prepare: false,
      isAnswerQuestion: false, // 是否已经答过题了
      isCountDownRunning: false, // 倒计时是否正在运行
      isCountDownPaused: false, // 倒计时是否暂停
      seconds: 0, // 当前倒计时秒数
      formTimeStr: '00:00', // 倒计时格式化字符串
      countDownTimer: null, // 倒计时定时器
      matchTng: 0, // 比赛状态
      noStart: false, // 比赛未开始
      examData: null, // 考试数据
      resultShow: false, // 结果展示
      base: env.baseWebIP
    }
  },
  computed: {
    dialogWidth () {
      const screenWidth = window.innerWidth
      if (screenWidth <= 768) {
        return '90%'
      } else if (screenWidth <= 1024) {
        return '70%'
      } else if (screenWidth <= 1440) {
        return '60%'
      } else {
        return '50%'
      }
    }
  },
  mounted () {
    this.getScreenSize()
    window.addEventListener('resize', this.getScreenSize)
  },
  beforeDestory () {
    window.removeEventListener('resize', this.getScreenSize)
  },
  created () {
    clearInterval(this.timer)
    console.log('this.$route.query', this.$route.query)
    document.title = '汉英双拼大会'
    const season = this.$route.query.season
    this.raceSchedule = this.$route.query.raceSchedule // 赛程
    const activityType = this.$route.query.activityType
    this.examinationRoomId = this.$route.query.examinationRoomId
    this.phase = this.$route.query.phase
    const level = Number(this.$route.query.level)
    this.group = Number(this.$route.query.group)
    this.level = level
    this.activityType = activityType
    this.season = season
    this.seasonClass = 'season2'
    console.log('PAD_USER_INFO=========', JSON.parse(localStorage.getItem('PAD_USER_INFO')))
    this.userInfo = JSON.parse(localStorage.getItem('PAD_USER_INFO'))

    this.getMatchStart(activityType, season, level)
    this.timer = setInterval(() => {
      this.getMatchStart(activityType, season, level)
    }, 3000)
  },
  methods: {
    getScreenSize () {
      const w = window.innerWidth
      const h = window.innerHeight
      if (h > w) { // 竖屏
        this.vertical = 'vertical'
        // this.pageStyle.height = parseInt(w * w / h) + 'px'
      } else {
        this.vertical = ''
        // this.pageStyle.height = '100%'
      }
      // console.log(this.vertical)
    },
    requestFullScreen () {
      const de = document.documentElement
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    exitFullscreen () {
      const de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    toFullOrExit () {
      this.isFull = !this.isFull
      if (this.isFull) {
        // this.fullImg = require('@/assets/img/efs.png')
        this.requestFullScreen()
      } else {
        // this.fullImg = require('@/assets/img/fs.png')
        this.exitFullscreen()
      }
    },
    /**
                 * 获取字典组
                 */
    getDictGroup () {
      // 这里需要根据实际情况获取字典组数据
      // 暂时使用空数组，实际项目中需要调用API获取
      this.dict_group = []
    },
    /**
                 * 获取比赛状态
                 */
    getMatchStart (activityType, season, level) {
      const params = {
        activityType: this.activityType,
        season: this.season,
        isGroup: this.group,
        raceSchedule: this.raceSchedule,
        examinationRoomId: this.examinationRoomId,
        phase: this.phase
      }
      if (Number(this.group) === 1) {
        params.level = level
      }
      queryNationalGroupFormInfoList(params).then(res => {
        if (res.code === 200) {
          if (!res.data.matchTng) {
            this.noStart = true
            return
          }
          this.matchTng = res.data.matchTng
          if (res.data.matchTng === 0) {
            this.noStart = true
          } else if (res.data.matchTng === 1) {
            this.noStart = false
            if (res.data.groupFormInfo) {
              const info = { ...res.data.groupFormType, ...res.data.groupFormInfo }

              // 检查是否是新题目
              const isNewQuestion = !this.info.id || this.info.id !== info.id
              this.info = { ...res.data.groupFormType, ...res.data.groupFormInfo }
              this.pageTitle = this.group === 2 ? this.info.typeName + ' ' + this.info.typeEngName : `小组赛${this.levelFormatter(level, 'cn')} Group Competition ${this.levelFormatter(level, 'en')}`

              // 作废题目状态重置
              if (info.isDiscard === 0) {
                this.isDiscard = false
                this.discardSubmit = false
                this.isSubmitting = false
              }

              const quizIng = res.data.groupFormInfo.quizIng
              if (quizIng === 1) { // 答题中
                // 只有在新题目时才重置提交状态
                if (isNewQuestion) {
                  this.isAnswerQuestion = true
                  this.prepare = false
                  this.submit = false
                  this.discardSubmit = false
                  this.isSubmitting = false
                }

                // 只有在新题目且未开始倒计时且题目未作废时才启动倒计时
                if (isNewQuestion && !this.isCountDownRunning && info.isDiscard === 0) {
                  this.startCountDown()
                }

                // 答案 - 只有在新题目时才重新设置
                if (isNewQuestion) {
                  const answerNum = info.answer.split(',').length
                  this.answerNum = answerNum
                }

                // 选项 - 只有在新题目或题目作废时才重置
                if (info.isDiscard === 0 && (isNewQuestion || !this.fontList.length)) {
                  // 重置选项状态
                  this.fontList = []
                  this.fontListB = []
                  this.imgList = []
                  this.chooseFonts = []
                  this.chooseFontsLeft = []
                  this.chooseFontsRight = []
                  this.chooseImg = ''

                  // 将选项分成两部分，分别设置给两个九宫格
                  const leftOptions = this.info.choice.split(',')
                  const rightOptions = this.info.choiceB.split(',')
                  const fontList = leftOptions.map(item => {
                    return {
                      active: false,
                      font: item,
                      isImg: item.includes('http') ? 1 : 0
                    }
                  })
                  this.fontList = fontList

                  const fontListB = rightOptions.map(item => {
                    return {
                      active: false,
                      font: item,
                      isImg: item.includes('http') ? 1 : 0
                    }
                  })
                  this.fontListB = fontListB
                  if (info.quizType === 6) { // 古往今来选项
                    const imgOpt = info.choicePic.split(',')
                    const imgList = imgOpt.map(item => {
                      return {
                        active: false,
                        font: item
                      }
                    })
                    this.imgList = imgList
                  }
                }

                // 暂停答题
                if (info.countDown === 1 && !this.isCountDownPaused) {
                  console.log('暂停计时')
                  this.pauseCountdown()
                }

                // 继续作答
                if (info.countDown === 2 && this.isCountDownPaused) {
                  console.log('继续作答')
                  this.resumeCountdown()
                }

                // 题目作废提交答案
                if (info.isDiscard === 1 && !this.isDiscard) {
                  console.log('题目作废，立即提交答案')
                  this.isDiscard = true
                  this.pause = false
                  this.stopCountdown()
                  if (!this.discardSubmit && !this.isSubmitting) {
                    this.submitFn('saveData')
                  }
                }

                // 题目作废时重置选项状态
                if (info.isDiscard === 1 && !this.isDiscard) {
                  this.fontList = []
                  this.fontListB = []
                  this.imgList = []
                  this.chooseFonts = []
                  this.chooseFontsLeft = []
                  this.chooseFontsRight = []
                  this.chooseImg = ''
                }
              }
            } else {
              this.noStart = false
              // 没有题目信息时停止倒计时
              this.stopCountdown()
              if (!this.submit && !this.discardSubmit && !this.isSubmitting) {
                if (this.info.id && !this.submit) { // 如果有题目信息则提交
                  this.submitFn('saveData')
                } else {
                  if (!this.isAnswerQuestion) { // 准备开始答题了
                    this.prepare = true
                    this.discardSubmit = false
                  } else { // 证明是已经结束了一题，中途进入，则提示本题已结束，等待下一题
                    this.submit = true
                    this.discardSubmit = false
                  }
                }
              }
            }
          } else if (res.data.matchTng === 2) {
            this.stopCountdown()
            this.stopTimerdown()
            this.submit = false
            this.isDiscard = false
            this.discardSubmit = false
            this.resultShow = true
          }
        }
      })
    },
    resultBtnTap () {
      this.$router.go(-1)
    },
    /**
         * 确认答案按钮点击事件
         */
    confirmAnswer () {
      this.resultShow = false
      // 将赛区和考场数据保存到本地存储
      const examRoomData = {
        districtId: this.$route.query.districtId || '',
        examinationRoomId: this.$route.query.examinationRoomId || '',
        season: this.$route.query.season || '',
        activityType: this.$route.query.activityType || '',
        raceSchedule: this.$route.query.raceSchedule || '',
        group: this.$route.query.group || '',
        level: this.$route.query.level || '',
        phase: this.$route.query.phase || '',
        returnToInput: true
      }
      localStorage.setItem('EXAM_ROOM_DATA', JSON.stringify(examRoomData))

      // 返回上一页（semiThirdRound界面）
      this.$router.go(-1)
    },
    /**
                 * 开始倒计时
                 */
    startCountDown () {
      // 确保不会重复启动倒计时
      if (this.isCountDownRunning) {
        return
      }

      this.stopCountdown()
      const initialSeconds = this.info.quizTime || 60
      this.seconds = initialSeconds
      this.formTimeStr = this.sec_to_time(initialSeconds.toString()).substr(3, 5)
      this.isCountDownRunning = true
      this.isCountDownPaused = false
      this.pause = false

      const countDownTimer = setInterval(() => {
        let currentSeconds = this.seconds
        if (currentSeconds <= 0) {
          this.formTimeStr = '00:00'
          this.seconds = 0
          this.stopCountdown()
          // 倒计时结束自动提交
          if (!this.submit && !this.discardSubmit && !this.isSubmitting) {
            this.submitFn('countdownOver')
          }
        } else {
          currentSeconds--
          const formTimeStr = this.sec_to_time(currentSeconds.toString()).substr(3, 5)
          console.log('formTimeStr', formTimeStr)
          this.formTimeStr = formTimeStr
          this.seconds = currentSeconds
        }
      }, 1000)

      this.countDownTimer = countDownTimer
    },

    /**
                 * 暂停倒计时
                 */
    pauseCountdown () {
      if (this.countDownTimer && this.isCountDownRunning && !this.isCountDownPaused) {
        clearInterval(this.countDownTimer)
        this.isCountDownPaused = true
        this.pause = true
      }
    },

    /**
                 * 恢复倒计时
                 */
    resumeCountdown () {
      if (this.isCountDownPaused && this.seconds > 0) {
        this.isCountDownPaused = false
        this.pause = false

        const countDownTimer = setInterval(() => {
          let currentSeconds = this.seconds
          if (currentSeconds <= 0) {
            this.formTimeStr = '00:00'
            this.seconds = 0
            this.stopCountdown()
            // 倒计时结束自动提交
            if (!this.submit && !this.discardSubmit && !this.isSubmitting) {
              this.submitFn('countdownOver')
            }
          } else {
            currentSeconds--
            const formTimeStr = this.sec_to_time(currentSeconds.toString()).substr(3, 5)
            console.log('formTimeStr', formTimeStr)
            this.formTimeStr = formTimeStr
            this.seconds = currentSeconds
          }
        }, 1000)

        this.countDownTimer = countDownTimer
      }
    },

    /**
                 * 停止倒计时
                 */
    stopCountdown () {
      if (this.countDownTimer) {
        clearInterval(this.countDownTimer)
        this.countDownTimer = null
      }
      this.isCountDownRunning = false
      this.isCountDownPaused = false
      this.countDownTimer = null
    },

    stopTimerdown () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    // 保存答案
    submitFn (subType) {
      // 防止重复提交
      if (this.isSubmitting) {
        console.log('正在提交中，避免重复调用')
        return
      }

      console.log('保存答案')
      // 立即设置提交状态，防止重复调用
      this.isSubmitting = true

      const calcResult = this.calcScore()
      console.log('calcResult', calcResult)
      console.log('this.info', this.info)
      const data = {
        activityType: this.activityType,
        season: this.season,
        userId: this.userInfo.userId || '-1',
        score: calcResult.score,
        nationalId: this.userInfo.id || '-1',
        nationalFormId: this.info.nationalFormId,
        nationalFormInfoId: this.info.id,
        nationalGroupId: this.userInfo.nationalGroupId || '-1',
        answer: calcResult.answer,
        isGroup: this.group,
        phase: this.phase,
        raceSchedule: this.raceSchedule
      }
      saveNationalAnswerResult(data).then(res => {
        if (res.code === 200) {
          if (!this.isDiscard) {
            if (subType !== 'countdownOver') {
              this.submit = true
            }
          } else {
            this.discardSubmit = true
          }
          this.pause = false
          this.isCountDownRunning = false
          this.isCountDownPaused = false
          this.isSubmitting = false
        } else {
          // 接口调用失败时也要重置提交状态
          this.isSubmitting = false
        }
      }).catch(err => {
        // 接口调用异常时也要重置提交状态
        console.error('提交答案失败:', err)
        this.isSubmitting = false
      })
    },

    /**
                 * 计算分数
                 */
    calcScore () {
      // 拆解两边的选择结果，每边只取字符串的第一位字符
      const leftAnswer = this.chooseFontsLeft.length > 0 ? this.chooseFontsLeft[0].charAt(0) : ''
      const rightAnswer = this.chooseFontsRight.length > 0 ? this.chooseFontsRight[0].charAt(0) : ''

      // 合并两边的第一位字符
      const stuList = [leftAnswer, rightAnswer]

      if (this.info.quizType === 6 && this.chooseImg) {
        if (!stuList.filter(item => item.includes('http')).length) {
          stuList.push(this.chooseImg)
        }
      }
      console.log('左边选择的答案:', this.chooseFontsLeft)
      console.log('右边选择的答案:', this.chooseFontsRight)
      console.log('拆解后的答案:', stuList)
      if (stuList.length > 0) {
        const ansList = this.info.answer.split(',')
        const inCorrect = ansList.filter(font => !stuList.includes(font))

        return {
          score: inCorrect.length ? 0 : this.info.questionScore,
          answer: stuList.join(',')
        }
      } else {
        return {
          score: 0,
          answer: ''
        }
      }
    },

    /**
                 * 格式化等级
                 */
    levelFormatter (level, type) {
      const item = this.dict_group.find(item => item.dictCode === level)
      return item ? item[type] : ''
    },

    // 左边九宫格选择答案
    answerFnLeft (item, index) {
      const fontList = [...this.fontList]
      const indexInFontList = fontList.findIndex(f => f.font === item.font)

      // 如果当前选项已经选中，则取消选择
      if (fontList[indexInFontList].active) {
        fontList[indexInFontList].active = false
        this.chooseFontsLeft = []
      } else {
        // 单选逻辑：先清除所有选择，再选中当前选项
        fontList.forEach(f => {
          f.active = false
        })
        fontList[indexInFontList].active = true
        this.chooseFontsLeft = [item.font]
      }

      this.fontList = fontList
      // 合并两边的选择结果
      this.chooseFonts = [...this.chooseFontsLeft, ...this.chooseFontsRight]
    },

    // 右边九宫格选择答案
    answerFnRight (item, index) {
      const fontListB = [...this.fontListB]
      const indexInFontList = fontListB.findIndex(f => f.font === item.font)

      // 如果当前选项已经选中，则取消选择
      if (fontListB[indexInFontList].active) {
        fontListB[indexInFontList].active = false
        this.chooseFontsRight = []
      } else {
        // 单选逻辑：先清除所有选择，再选中当前选项
        fontListB.forEach(f => {
          f.active = false
        })
        fontListB[indexInFontList].active = true
        this.chooseFontsRight = [item.font]
      }

      this.fontListB = fontListB
      // 合并两边的选择结果
      this.chooseFonts = [...this.chooseFontsLeft, ...this.chooseFontsRight]
    },

    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    // 获取弹窗宽度
    getDialogWidth () {
      const screenWidth = window.innerWidth
      if (screenWidth < 768) {
        return '90%'
      } else if (screenWidth < 1024) {
        return '70%'
      } else if (screenWidth < 1440) {
        return '60%'
      } else {
        return '50%'
      }
    },
    /**
                 * 时间格式化工具函数
                 */
    sec_to_time (s) {
      let t
      if (s > -1) {
        const hour = Math.floor(s / 3600)
        const min = Math.floor(s / 60) % 60
        const sec = s % 60
        if (hour < 10) {
          t = '0' + hour + ':'
        } else {
          t = hour + ':'
        }

        if (min < 10) { t += '0' }
        t += min + ':'
        if (sec < 10) { t += '0' }
        t += sec.toFixed(0)
      }
      return t
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style scoped lang="less">
.fullscreen {
    width: 32px;
    height: 32px;
    position: fixed;
    right: 10px;
    bottom: 10px;
    cursor: pointer;
}
.screen {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-family: "regular";
}
.page {
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg2.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
}
.page1 {
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg1.png);
}
.header {
    margin-top: 32px;
    height: 84px;
    display: flex;
    justify-content: center;
    position: relative;
    .logo {
        width: 220px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
    }
    .title {
        font-size: 28px;
        color: #fff;
        background-color: #b81c25;
        height: 54px;
        line-height: 49px;
        border-radius: 54px;
        padding-left: 30px;
        padding-right: 30px;
        margin-top: 20px;
    }
    .title1 {
        background-color: #000;
    }
}
.desc {
    margin: 40px 60px 52px;
    line-height: 24px;
    font-size: 16px;
    color: #000;
}
.content {
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
.answer-area {
    .flex {
        display: flex;
    }
    .block {
        width: 140px;
        height: 140px;
        font-size: 90px;
        color: #000;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        text-align: center;
        padding-top: 10px;
        box-sizing: border-box;
        border-radius: 30px;
        background-color: #e5e5e5;
        margin: 10px;
    }
    .block2 {
        background-color: transparent;
    }
}
.stem-area {
    width: 318px;
    height: 318px;
    margin-right: 80px;
}
.type1 {
    .block {
        width: 66px;
        height: 66px;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        text-align: center;
        padding-top: 4px;
        box-sizing: border-box;
        font-size: 40px;
        background-color: #ffb700;
        box-shadow: inset 2px 2px 15px rgba(0, 0, 0, 0.4);
        border: 2px solid #000;
        border-radius: 18px;
        margin-bottom: 10px;
    }
}
.type2 {
    position: relative;
    .block {
        width: 66px;
        height: 66px;
        font-size: 40px;
        background-color: #fe7d4d;
        border: 2px solid #000;
        border-radius: 18px;
        margin-bottom: 10px;
        position: absolute;
        &.block0 {
            top: 0;
            left: 0;
        }
        &.block1 {
            top: 0;
            left: 76px;
        }
        &.block2 {
            top: 0;
            left: 152px;
        }
        &.block3 {
            top: 0;
            left: 228px;
        }
        &.block4 {
            top: 76px;
            left: 0;
        }
        &.block5 {
            top: 76px;
            left: 228px;
        }
        &.block6 {
            top: 152px;
            left: 0;
        }
        &.block7 {
            top: 152px;
            left: 228px;
        }
        &.block8 {
            top: 228px;
            left: 0;
        }
        &.block9 {
            top: 228px;
            left: 76px;
        }
        &.block10 {
            top: 228px;
            left: 152px;
        }
        &.block11 {
            top: 228px;
            left: 228px;
        }
    }
    .block-inner {
        width: 66px;
        height: 66px;
        text-align: center;
        padding-top: 4px;
        box-sizing: border-box;
        border-radius: 16px;
        box-shadow: inset 2px 2px 15px rgba(0, 0, 0, 0.4);
    }
    .center {
        width: 142px;
        height: 142px;
        position: absolute;
        top: 76px;
        left: 76px;
        border-radius: 28px;
        font-size: 96px;
        text-align: center;
    }
}
.content3 {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .imageData {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin: 20px 0px;

        .quiz-info {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;

            .quiz-number {
                font-size: 24px;
                font-weight: bold;
                color: #b81c25;
                background-color: #fff;
                padding: 8px 16px;
                border-radius: 20px;
                border: 2px solid #b81c25;
                min-width: 100px;
                text-align: center;
            }

            .quiz-image {
                flex: 1;
                min-width: 60px;
                min-height: 60px;
                display: flex;
                justify-content: center;
                margin: 0 10px;

                img {
                    max-width: 25%;
                    max-height: 200px;
                    border-radius: 20px;
                }
            }

            .countdown {
                font-size: 24px;
                font-weight: bold;
                color: #fff;
                background-color: #b81c25;
                padding: 8px 10px;
                font-family: fzcsk;
                border-radius: 20px;
                border: 2px solid #fff;
                min-width: 100px;
                text-align: center;
            }
        }

        // 响应式设计
        @media (max-width: 768px) {
            .quiz-info {
                .quiz-number {
                    font-size: 18px;
                    padding: 6px 10px;
                    min-width: 80px;
                }

                .quiz-image {
                    margin: 0 5px;

                    img {
                        max-width: 60%;
                        max-height: 150px;
                    }
                }

                .countdown {
                    font-size: 18px;
                    padding: 6px 10px;
                    min-width: 80px;
                }
            }
        }

        @media (min-width: 769px) and (max-width: 1024px) {
            .quiz-info {
                padding: 0 15px;

                .quiz-number {
                    font-size: 20px;
                    padding: 7px 14px;
                }

                .quiz-image {
                    margin: 0 10px;

                    img {
                        max-width: 30%;
                        max-height: 180px;
                    }
                }

                .countdown {
                    font-size: 20px;
                    padding: 7px 14px;
                }
            }
        }

        img {
            max-width: 25%;
            max-height: 200px;
            border-radius: 20px;
        }
    }
}
.type3 {
    display: flex;
    align-items: center;
    justify-content: center;

    .grid-container {
        display: flex;
        gap: 40px;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        max-width: 800px;
        flex-wrap: nowrap;

        @media (max-width: 720px) {
            gap: 10px;
            justify-content: space-between;
            max-width: 100%;
        }

        @media (min-width: 721px) and (max-width: 1023px) {
            gap: 20px;
        }

        @media (max-width: 480px) {
            gap: 8px;
        }

        @media (max-width: 320px) {
            gap: 5px;
        }
    }

    .left-grid-wrapper,
    .right-grid-wrapper {
        border: 3px solid #b81c25;
        border-radius: 20px;
        padding: 20px;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(5px);
        box-shadow: 0 4px 15px rgba(184, 28, 37, 0.2);
        flex: 1;
        min-width: 0;

        @media (max-width: 720px) {
            padding: 8px;
            border-radius: 10px;
            border-width: 2px;
        }

        @media (min-width: 721px) and (max-width: 1023px) {
            padding: 15px;
            border-radius: 16px;
        }

        @media (max-width: 480px) {
            padding: 6px;
            border-radius: 8px;
            border-width: 1px;
        }

        @media (max-width: 320px) {
            padding: 4px;
            border-radius: 6px;
        }
    }

    .left-grid-wrapper {
        border-color: #b81c25;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: linear-gradient(45deg, #b81c25, #ff6b6b);
            border-radius: 22px;
            z-index: -1;
            opacity: 0.3;

            @media (max-width: 720px) {
                border-radius: 17px;
            }
        }
    }

    .right-grid-wrapper {
        border-color: #409eff;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: linear-gradient(45deg, #409eff, #67c23a);
            border-radius: 22px;
            z-index: -1;
            opacity: 0.3;

            @media (max-width: 720px) {
                border-radius: 17px;
            }
        }
    }

    .grid-title {
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin-bottom: 15px;
        padding: 8px 0;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.1);

        @media (max-width: 720px) {
            font-size: 12px;
            margin-bottom: 6px;
            padding: 3px 0;
        }

        @media (min-width: 721px) and (max-width: 1023px) {
            font-size: 16px;
            margin-bottom: 12px;
        }

        @media (max-width: 480px) {
            font-size: 10px;
            margin-bottom: 4px;
            padding: 2px 0;
        }

        @media (max-width: 320px) {
            font-size: 9px;
            margin-bottom: 3px;
            padding: 1px 0;
        }
    }
    .block {
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        // border: 6px solid #b81c25;
        border: 4px solid #fff;

        border-radius: 20px;
        margin-right: 16px;
        &.active {
            border-color: #b81c25;
        }
        img {
            height: 90%;
            border-radius: 12px;
        }
    }
    .area2 {
        width: 262px;
        margin-left: 0;
        .block2 {
            width: 76px;
            height: 76px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            box-sizing: border-box;
            font-family: "fzcsk";
            font-size: 36px;
            background-color: #e5e5e5;
            box-shadow: inset 2px 2px 15px rgba(0, 0, 0, 0.4);
            border: 2px solid #000;
            border-radius: 14px;
            margin-bottom: 10px;
            &.active {
                border-color: #b81c25;
                background-color: #ffb700;
            }
        }
    }

    // 只针对九宫格区域的响应式设计
    @media (max-width: 650px) {
        .area2 {
            width: 100%;
            margin-left: 0;
            .block2 {
                width: 40px;
                height: 40px;
                font-size: 16px;
                padding-top: 2px;
                border-radius: 6px;
                margin-bottom: 4px;
            }
        }
    }

    @media (max-width: 480px) {
        .area2 {
            width: 100%;
            margin-left: 0;
            .block2 {
                width: 32px;
                height: 32px;
                font-size: 14px;
                padding-top: 1px;
                border-radius: 5px;
                margin-bottom: 3px;
            }
        }
    }

    @media (max-width: 320px) {
        .area2 {
            width: 100%;
            margin-left: 0;
            .block2 {
                width: 28px;
                height: 28px;
                font-size: 12px;
                padding-top: 1px;
                border-radius: 4px;
                margin-bottom: 2px;
            }
        }
    }

    @media (min-width: 651px) and (max-width: 1023px) {
        .area2 {
            width: 100%;
            margin-left: 0;
            .block2 {
                width: 55px;
                height: 55px;
                font-size: 24px;
                padding-top: 4px;
                border-radius: 10px;
                margin-bottom: 6px;
            }
        }
    }

    @media (min-width: 1024px) and (max-width: 1439px) {
        .area2 {
            width: 100%;
            margin-left: 0;
            .block2 {
                width: 68px;
                height: 68px;
                font-size: 30px;
                padding-top: 5px;
                border-radius: 12px;
                margin-bottom: 8px;
            }
        }
    }

    @media (min-width: 1440px) {
        .area2 {
            width: 320px;
            margin-left: 45px;
            .block2 {
                width: 85px;
                height: 85px;
                font-size: 40px;
                padding-top: 8px;
                border-radius: 15px;
                margin-bottom: 12px;
            }
        }
    }
}
.answer-area-title {
    font-size: 22px;
    color: #b81c25;
    background-color: #000;
    width: 150px;
    text-align: center;
    height: 40px;
    line-height: 36px;
    border-radius: 120px;
    margin: 0 auto 12px;
}
.content4 {
    .flex {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 24px;
    }
    .group-block {
        width: 120px;
        height: 120px;
        text-align: center;
        padding-top: 14px;
        box-sizing: border-box;
        font-size: 68px;
        background-color: #e5e5e5;
        box-shadow: inset 2px 2px 15px rgba(0, 0, 0, 0.4);
        border: 2px solid #000;
        border-radius: 20px;
        margin: 10px;
        &.active {
            border-color: #ffb700;
            background-color: #ffb700;
        }
    }
    .group-block-img {
        width: 120px;
        height: 120px;
        text-align: center;
        padding-top: 14px;
        box-sizing: border-box;
        font-size: 68px;
        background-color: #fff;
        border: 6px solid #000;
        box-shadow: inset 2px 2px 15px rgba(0, 0, 0, 0.4);
        border-radius: 20px;
        margin: 10px;
        &.active {
            border-color: #ffb700;
        }
    }
    .font-img {
        height: 80%;
    }
}
// 竖屏
.vertical {
    flex-direction: row;
    align-items: center;
    .stem-area {
        margin: 20px auto;
    }
}

/deep/ .el-dialog__header {
    display: none;
}
/deep/ .el-dialog {
    background-color: transparent;
    box-shadow: none;
}
.info-panel {
    min-height: 350px;
    max-height: 80vh;
    background-color: #cbae72;
    border: 3px solid #000;
    text-align: center;
    font-size: 32px;
    color: #000;
    box-sizing: border-box;

    @media (max-width: 768px) {
        min-height: 300px;
        font-size: 24px;
        border-width: 2px;
    }

    @media (min-width: 769px) and (max-width: 1024px) {
        min-height: 320px;
        font-size: 28px;
    }

    @media (min-width: 1025px) and (max-width: 1440px) {
        min-height: 330px;
        font-size: 30px;
    }
}
.confirm-button-container {
    margin-top: 30px;
    text-align: center;

    .confirm-btn {
        background-color: #b81c25;
        border-color: #b81c25;
        color: #fff;
        font-size: 18px;
        padding: 12px 30px;
        border-radius: 25px;
        font-weight: bold;

        &:hover {
            background-color: #a01820;
            border-color: #a01820;
        }

        .cn {
            display: block;
            font-size: 18px;
            line-height: 1.2;
        }

        .en {
            display: none;
            font-size: 14px;
            line-height: 1.2;
        }

        @media (max-width: 768px) {
            padding: 10px 25px;
            font-size: 16px;

            .cn {
                font-size: 16px;
            }

            .en {
                font-size: 12px;
            }
        }
    }
}
.guodu {
    width: 120px;
    height: 120px;
    margin-bottom: 24px;

    @media (max-width: 768px) {
        width: 80px;
        height: 80px;
        margin-bottom: 16px;
    }

    @media (min-width: 769px) and (max-width: 1024px) {
        width: 100px;
        height: 100px;
        margin-bottom: 20px;
    }
}
.active-font {
    background-color: #d0d0d0 !important;
}

.info-title {
    margin-top: 20px;
    width: 100%;
    height: 100%;
    padding-top: 16px;
    box-sizing: border-box;
    text-align: center;
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
    // background-repeat: no-repeat;
    // background-position: center;
    // background-size: auto 100%;
    color: #fff;

    .cn {
        font-size: 26px;
    }
    .en {
        font-size: 20px;
    }

    @media (max-width: 768px) {
        .cn {
            font-size: 18px;
        }
        .en {
            font-size: 14px;
        }
    }

    @media (min-width: 769px) and (max-width: 1024px) {
        padding-top: 14px;

        .cn {
            font-size: 22px;
        }
        .en {
            font-size: 16px;
        }
    }
}
.userinfo {
    position: absolute;
    right: 24px;
    top: 14px;
    color: #000;
    font-size: 16px;
    font-family: fzcsk;
    .mr-20 {
        margin-right: 10px;
    }
}
.season1 {
    .page {
        background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg2.png);
    }
}
.season1 .page1 {
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_padU86_bg1.png);
}
.season2 {
    .page {
            background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/season4bg.jpg);

        display: flex;
        align-items: center;
        justify-content: center;
    }
    .season2-logo {
        position: absolute;
        left: 40px;
        right: 40px;
        top: 36px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .img {
            height: 40px;
            width: auto;
        }
    }
    .page-box {
        width: 94%;
        min-height: 70vh;
        background: rgba(255, 248, 225, 0.7);
        border-radius: 20px;
        padding: 30px 30px 20px;
        box-sizing: border-box;
        margin-top: 60px;
    }
    .userinfo {
        top: 104px;
        right: 58px;
    }
    .page2 {
        .userinfo {
            top: 8px;
            right: 24px;
        }
    }
    .answer-area-title {
        color: #fff;
    }
    .content4 .group-block {
        background-color: #fff8e1;
        box-shadow: none;
    }
    .content4 .group-block.active {
        background-color: #f8bc1c;
        box-shadow: inset 2px 2px 15px rgba(0, 0, 0, 0.1);
    }
    .content4 .group-block-img.active {
        border-color: #b81c25;
    }
    .season2-title {
        height: 64px;
        background-size: auto 100%;
        background-position: center;
        background-repeat: no-repeat;
        font-family: regular;
        text-align: center;
        padding-top: 12px;
        box-sizing: border-box;
        .cn {
            font-size: 20px;
        }
        .en {
            font-size: 12px;
        }
    }
    .season2-title1 {
        color: #000;
        background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg2.png);
    }
    .season2-title2 {
        color: #fff;
        background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
    }
    .page-box2 {
        // background: transparent;
        // margin-top: 0;
        .desc {
            // background: rgba(255, 248, 225, .7);
            // border-radius: 20px;
            padding: 20px;
            margin: 30px 0;
        }
    }
    .type2 {
        .block-inner {
            background-color: #fff8e1;
            box-shadow: none;
        }
        .block {
            background-color: #fff8e1;
        }
    }
    .answer-area {
        .block {
            border: 2px solid #000;
            background-color: #fff8e1;
        }
        .block2 {
            background: transparent;
            border: none;
        }
    }
    .active-font {
        background-color: #f8bc1c !important;
    }
    .type1 {
        .block {
            background-color: #fff8e1;
            box-shadow: none;
        }
    }
    .type3 {
        .area2 {
            .block2 {
                background-color: #fff8e1;
                box-shadow: none;
                &.active {
                    background-color: #f8bc1c;
                    border-color: #000;
                }
            }
        }
    }
}

.info-panel-season2 {
    width: 100%;
    border: none;
    background-color: transparent;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/rankbg.png);
    background-repeat: no-repeat;
    background-size: 90% 100%;
    background-position: center;
    padding: 50px 20px;
    box-sizing: border-box;
    .info-con {
        width: 40%;
        background-color: transparent;
        color: #000;
    }
    .info-title {
        color: #000;
        font-size: 24px;
        padding: 0 60px;
    }

    .confirm-button-container {
        margin-top: 30px;
        text-align: center;

        .confirm-btn {
            background-color: #000;
            border-color: #000;
            color: #fff;
            font-size: 18px;
            padding: 12px 30px;
            border-radius: 25px;
            font-weight: bold;

            &:hover {
                background-color: #333;
                border-color: #333;
            }

            .cn {
                display: none;
                font-size: 18px;
                line-height: 1.2;
            }

            .en {
                display: block;
                font-size: 14px;
                line-height: 1.2;
            }

            @media (max-width: 768px) {
                padding: 10px 25px;
                font-size: 16px;

                .cn {
                    font-size: 16px;
                }

                .en {
                    font-size: 12px;
                }
            }
        }
    }
}
/deep/ .season2-dialog {
    margin-top: 20vh !important;
    margin-bottom: 0 !important;
    .el-dialog__body {
        padding: 0;
    }
}
/* 全局设置所有 el-dialog 的背景遮罩层为黑色不透明 */
::v-deep .el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 1) !important;
}

/deep/ .el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 1) !important;
}
</style>
